import { render, staticRenderFns } from "./MobileAppsGroup.vue?vue&type=template&id=296dbda6&"
var script = {}
import style0 from "./MobileAppsGroup.vue?vue&type=style&index=0&id=296dbda6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports